import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

// APROBADOS por Jesús el 25 Oct 2026.
export const TEXTOS_SOLICITUDES = {
  titulo: "Solicitudes por aprobar",
  paciente: "Paciente", telefono: "Teléfono", servicio: "Servicio", prestador: "Prestador",
  motivo: "Motivo", recibida: "Recibida", sinMotivo: "Sin motivo",
  abrir: "Abrir conversación", atender: "Marcar como atendida",
  error: "No pudimos marcar la solicitud como atendida. Inténtalo de nuevo.",
};

export default function SolicitudesAprobacion() {
  const { user, puede } = useAuth();
  const [items, setItems] = useState([]);
  const [ocupadas, setOcupadas] = useState([]);
  const [error, setError] = useState("");
  const clinicId = user?.active_clinic_id;
  const autorizado = puede("agenda");
  useEffect(() => {
    let vigente = true;
    setItems([]);
    setError("");
    if (autorizado && clinicId) {
      api.get("/solicitudes-aprobacion", { params: { estado: "pendiente" } })
        .then(({ data }) => { if (vigente) setItems(Array.isArray(data.items) ? data.items : []); })
        .catch(() => { if (vigente) setItems([]); });
    }
    return () => { vigente = false; };
  }, [clinicId, autorizado]);

  async function atender(id) {
    setOcupadas((actual) => [...actual, id]);
    setError("");
    try {
      await api.patch(`/solicitudes-aprobacion/${id}`, { estado: "atendida" });
      setItems((actual) => actual.filter((item) => item.id !== id));
    } catch {
      setError(TEXTOS_SOLICITUDES.error);
    } finally {
      setOcupadas((actual) => actual.filter((valor) => valor !== id));
    }
  }

  if (!autorizado || !clinicId || !items.length) return null;
  const t = TEXTOS_SOLICITUDES;
  return (
    <section id="solicitudes-aprobacion" aria-labelledby="solicitudes-titulo" className="bg-white border border-slate-200 rounded-2xl p-4 space-y-3">
      <h2 id="solicitudes-titulo" className="font-semibold text-lg">{t.titulo} ({items.length})</h2>
      {error && <p role="alert">{error}</p>}
      <ul className="space-y-4">
        {items.map((item) => (
          <li key={item.id} className="border-t border-slate-100 pt-3" data-testid={`solicitud-${item.id}`}>
            <dl className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm break-words">
              {[[t.paciente, item.patient_name], [t.telefono, item.patient_identifier],
                [t.servicio, item.service_name], [t.prestador, item.doctor_name],
                [t.motivo, item.motivo || t.sinMotivo],
                [t.recibida, new Date(item.created_at).toLocaleString("es-MX", { timeZone: item.clinic_timezone || "America/Mexico_City", hour12: false })]
              ].map(([etiqueta, valor]) => <div key={etiqueta}><dt className="text-slate-500">{etiqueta}</dt><dd>{valor}</dd></div>)}
            </dl>
            <div className="flex flex-wrap gap-3 mt-3 text-sm">
              <a href="/app/inbox" className="text-blue-700 underline">{t.abrir}</a>
              <button type="button" disabled={ocupadas.includes(item.id)} onClick={() => atender(item.id)} className="rounded-lg border px-3 py-2 disabled:opacity-50">{t.atender}</button>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
